<template>
  <div>
    <el-dialog :title="title"
               :visible.sync="dialogFormVisible"
               width="450px"
               top="30px"
               :close-on-click-modal="false"
               @close="emitClose"
               @open="open()">
      <el-form ref="searchForm"
               :inline="true"
               :model="dataForm">
        <el-form-item label="选择分组"
                      prop="order_no">
          <el-select v-model="dataForm.category_id"
                     placeholder="请选择"
                     clearable
                     style="width:300px;">
            <el-option v-for="item in result"
                       :key="item.id"
                       :label="item.name"
                       :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="评论内容"
                      prop="order_no">
          <el-input type="textarea"
                    placeholder="请输入评论内容"
                    style="width:300px;"
                    rows="6"
                    v-model="dataForm.content"></el-input>
        </el-form-item>
      </el-form>
      <div class="footer">
        <div class="cancle"
             @click="emitClose()">取消</div>
        <div class="confirm"
             @click="handleSubmit()">确定</div>
      </div>

    </el-dialog>
  </div>
</template>
<script >
import { categoryList, Creatematerial, Putmaterial } from '@/api/note'
export default {
  props: {
    visible: {
      type: Boolean,
      default: () => {
        return false
      },
    },
    title: {
      type: String,
      default: () => {
        return ''
      },
    },
    detailRow: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  watch: {
    visible(val) {
      this.dialogFormVisible = val
    },
    detailRow(val) {
      if (val) {
        this.dataForm.content = val.content
        this.dataForm.category_id = this.detailRow.category_id
      }
    },
  },
  data() {
    return {
      dialogFormVisible: false,
      dataForm: { content: '', category_id: '' },
      result: [],
    }
  },
  methods: {
    open() {
      this.getCategoryList()
    },
    emitClose() {
      this.dataForm.content = ''
      this.dataForm.category_id = ''
      this.$emit('close')
    },
    getCategoryList() {
      categoryList({ isPaging: 0 }).then((res) => {
        this.result = res.list
      })
    },
    handleSubmit() {
      if (this.dataForm.content == '') {
        this.$message.error('请输入评论内容!')
        return
      }
      if (this.dataForm.category_id.length == 0) {
        this.$message.error('请选择分组!')
        return
      }

      if (this.title == '新建评论') {
        let data = {
          arr_data: [],
        }
        data.arr_data.push({
          category_id: this.dataForm.category_id,
          content: this.dataForm.content,
        })
        Creatematerial(data).then((res) => {
          this.$message.success('创建成功!')
          this.emitClose()
        })
      } else {
        // data.id = this.detailRow.id
        let editData = {
          id: this.detailRow.id,
          category_id: this.dataForm.category_id,
          content: this.dataForm.content,
        }
        Putmaterial(editData).then((res) => {
          this.$message.success('创建成功!')
          this.emitClose()
        })
      }
    },
  },
}
</script>
<style lang="less" scoped>
::v-deep .el-dialog__header {
  background: #ebeef5;
}
.footer {
  cursor: pointer;
  display: flex;
  justify-content: flex-end;
  .cancle {
    text-align: center;
    width: 56px;
    height: 32px;
    line-height: 32px;
    border-radius: 4px 4px 4px 4px;
    border: 1px solid #cccccc;
    margin-right: 10px;
  }
  .confirm {
    text-align: center;
    width: 56px;
    height: 32px;
    color: #fff;
    line-height: 32px;
    background: #409eff;
    border-radius: 4px 4px 4px 4px;
  }
}
</style>